<template>
  <div>
    <div class="footer">
      <div>
        <div style="height: 200px;position:relative;">
          <div class="footer-item" style="margin-top:27px;margin-left: 60px;margin-right: 30px;">
            <img src="../../assets/image/weixin.jpg" height="150px" alt="微信二维码">
          </div>
          <!--          <div style="display: flex;flex-direction: column">

                      <a href="https://beian.miit.gov.cn/" class="no-style" target="_blank">渝ICP备2022008259号-1</a>
                    </div>-->
          <img src="../../assets/image/beian.png" style="height: 20px;width: 20px">
          <a href="https://beian.miit.gov.cn/" class="no-style" target="_blank">{{ beian }}</a>
<!--          <span>{{ beian }}</span>-->
          <div class="footer-item" style="margin-left: 60px;margin-right: 60px;position: absolute;left: 20%;top: 18%">
            <h2 style="margin-bottom: 8px">联系我</h2>
            <div class="cursor-point">Email : 2097574648@qq.com</div>
            <div class="cursor-point">QQ : 2097574648</div>
          </div>

          <div class="footer-item" style="margin-left: 60px;margin-right: 60px;position: absolute;left: 50%;top: 18%">
            <h2 style="margin-bottom: 8px">博客简介</h2>
            <div class="cursor-point">梦想还是要有的，万一实现了呢~</div>
            <div class="cursor-point">咸鱼也会翻身，是吧~</div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {
      ran: '渝ICP备2022008259号-1',
      li: '晋ICP备2024028686号-1',
      beian: ''
    }
  },
  mounted() {
    let domain = window.location.hostname;
    console.log("当前域名是：" + domain);
    if (domain.includes('feiyiyishu')) {
      this.beian = this.li
    } else {
      this.beian = this.ran
    }
  }
}
</script>

<style scoped>
.footer {
  left: 0;
  bottom: 0 !important;
  line-height: 2;
  position: relative;
  color: #eee;
  width: 100%;
  height: 200px;
  font-size: 14px;
  background-color: #545c64;
  transition: .2s;
}

.footer-item {
  display: inline-block;
  text-align: center;
  padding-left: 60px;
  padding-right: 60px;
}

.cursor-point {
  cursor: pointer;
}

.no-style {
  text-decoration: none;
  color: inherit;
}

.no-style:hover {
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/Footer.vue